<template>
  <div style="padding: 0 100px;">
    <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
    <a-form-item label="摄像头型号">
      <a-input v-model="name" />
    </a-form-item>
    <a-form-item label="IP地址">
      <a-input v-model="IP" />
    </a-form-item>
    <a-form-item label="账户名称">
      <a-input v-model="account" />
    </a-form-item>
    <a-form-item label="密码">
      <a-input v-model="password" />
    </a-form-item>
    <a-row type="flex" align="middle">
      <a-col :span="2">
        <div class="text-right">点位范围：</div>
      </a-col>
      <a-col :span="22">
        <a-slider
          v-if="size"
          @change="sizeChange"
          :defaultValue="size"
          :marks="marks"
          :min="6"
          :max="8"
          dots
          :tooltipVisible="false"
        />
      </a-col>
    </a-row>
    <!-- <a-row class="m-t-10"> -->
      <!-- <a-col :span="2">
        <div class="text-right m-t-8">定时拍摄：</div>
      </a-col>
      <a-col :span="15">
        <div class="width-full m-b-10">
          <a-time-picker
            style="width: 100%"
            format="HH:mm"
            valueFormat="HH:mm"
            v-model="time"
          />
        </div>
      </a-col> -->
      <!-- <a-col :span="15">
        <tk-flex
          v-for="(item, index) in times"
          :key="item + index"
          class="m-b-10"
        >
          <a-time-picker
            class="flex-grow m-r-10"
            format="HH:mm"
            valueFormat="HH:mm"
            v-model="times[index]"
          />
          <a-button v-if="index === times.length - 1" @click="addTimes"
            ><tk-flex middle
              ><a-icon type="plus" :style="{ fontSize: '14px' }"/></tk-flex
          ></a-button>
          <a-button v-else @click="deleteTimes(index)"
            ><tk-flex middle
              ><a-icon type="minus" :style="{ fontSize: '14px' }"/></tk-flex
          ></a-button>
        </tk-flex>
      </a-col> -->
    <!-- </a-row> -->
    <a-row class="m-t-10">
      <a-col :span="2">
        <div class="text-right">摄像头位置：</div>
      </a-col>
      <a-col :span="22">
        <div
          @mouseleave="stopChangeCenter"
          class="border-2 overflow-hidden relative"
          :class="isCircle ? 'rounded-full' : 'rounded-lg'"
          style="width: 100%; height: 0; box-sizing: border-box;background-color: #eee;"
          :style="{ paddingBottom: `${(vertical / horizontal) * 100}%` }"
        >
          <!-- 最底层，绘制背景小正方形 -->
          <div
            class="grid full-height absolute full-width -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2"
            :style="{
              gridTemplateColumns: `repeat(${horizontallength}, minmax(0, 1fr))`,
              gridTemplateRows: `repeat(${verticallegth}, minmax(0, 1fr))`,
              width: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              height: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              gap: '3px',
              zIndex: 0
            }"
          >
            <div
              v-for="item in gridSize"
              :key="item"
              class="relative"
              :style="{
                backgroundColor: '#fff'
              }"
            ></div>
          </div>
          <!-- 中间层，绘制其他摄像头占位 -->
          <div
            class="grid full-height absolute full-width -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2"
            :style="{
              gridTemplateColumns: `repeat(${horizontallength}, minmax(0, 1fr))`,
              gridTemplateRows: `repeat(${verticallegth}, minmax(0, 1fr))`,
              width: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              height: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              gap: '3px',
              zIndex: 0
            }"
          >
            <div
              v-for="item in showEq"
              :key="item.objectId"
              style="position: absolute; height: 0;background-color: #fff;border: 1px solid #ccc"
              :style="{
                width: `${(item.side / item.width) * 100}%`,
                left: `${getMinX(
                  item.left,
                  item.side,
                  item.width
                ) * 100}%`,
                top: `${getMinY(
                  item.top,
                  item.side,
                  item.height
                ) * 100}%`,
                height: `${(item.side / item.height) * 100}%`
              }"
            >
              <tk-flex
                center
                middle
                class="width-full height-full"
              >
                <EqCamera />
              </tk-flex>
            </div>
          </div>
          <!-- 最上层，绘制点位 -->
          <div
            class="grid full-height absolute full-width -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2"
            :style="{
              gridTemplateColumns: `repeat(${horizontallength}, minmax(0, 1fr))`,
              gridTemplateRows: `repeat(${verticallegth}, minmax(0, 1fr))`,
              width: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              height: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
              gap: '3px',
              zIndex: 1
            }"
          >
            <div
              v-for="item in gridSize"
              :key="item"
              class="relative"
              :style="{
                backgroundColor: !isInRange(item)
                  ? 'transparent'
                  : 'rgba(47, 191, 121, 0.3)'
              }"
              @mousedown.prevent="startChangeCenter(item)"
              @mouseup.prevent="stopChangeCenter()"
              @mousemove.prevent="changeCenter(item)"
              @click="clickItem(item)"
            >
              <tk-flex style="color:#AAADB3" class="height-full" middle center>
                {{ isInPoint(item) ? isInPoint(item) + "号" : "" }}
              </tk-flex>
              <tk-flex
                center
                v-show="isCenter(item)"
                class="left-dist dist"
                :style="{ width: `${100 * (left + 2)}%` }"
              >
                <div class="dist-desc">{{ leftLength }}m</div>
              </tk-flex>
              <tk-flex
                middle
                column
                v-show="isCenter(item)"
                class="top-dist dist"
                :style="{ height: `${100 * (top + 2)}%` }"
              >
                <div class="dist-desc">{{ topLength }}m</div>
              </tk-flex>
              <tk-flex
                center
                v-show="isCenter(item)"
                :style="{ width: `${100 * (horizontallength - left + 2)}%` }"
                class="right-dist dist"
              >
                <div class="dist-desc">{{ rightLength }}m</div>
              </tk-flex>
              <tk-flex
                middle
                column
                v-show="isCenter(item)"
                class="bottom-dist dist"
                :style="{ height: `${100 * (verticallegth - top + 2)}%` }"
              >
                <div class="dist-desc">{{ bottomLength }}m</div>
              </tk-flex>
              <div
                class="absolute top-0 left-0 -translate-y-full -translate-x-1/2"
                style="top: 0; left: 0;"
                v-show="isCenter(item)"
              >
                <CameraTag />
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-form>
  </div>
</template>
<script>
import { isIp } from '../../utils/validator.js'
import CameraTag from './cameraTag'
import EqCamera from './eqCamera'
// const multiple = 1.732 // 30
// const multiple = 2.747 // 20
export default {
  components: {
    CameraTag,
    EqCamera
  },
  props: {
    allEq: {
      type: Array,
      default: () => []
    },
    cameraLength: {
      type: Number,
      required: true
    },
    horizontal: {
      type: Number,
      required: true
    },
    vertical: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    storeId: {
      type: String,
      required: true
    },
    // name IP size password time left top
    setting: {
      type: Object
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    diameter: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      sidelength: 0,
      canUpdateCenter: false,
      // 数据
      name: '',
      IP: '',
      account: '',
      password: '',
      marks: {
        6: '大',
        7: '中',
        8: '小'
      },
      size: null,
      time: '',
      times: [''],
      // 外围矩形
      horizontallength: 0,
      verticallegth: 0,
      // 中心点
      left: 0,
      top: 0
    }
  },
  computed: {
    showEq () {
      if (this.setting) {
        return this.allEq.filter(
          element => element.objectId !== this.setting.objectId
        )
      } else {
        return this.allEq
      }
    },
    gridSize () {
      return this.horizontallength * this.verticallegth
    },
    minLeft () {
      return 0 + Math.floor(this.size / 2)
    },
    maxLeft () {
      return this.horizontallength - Math.ceil(this.size / 2)
    },
    minTop () {
      return 0 + Math.floor(this.size / 2)
    },
    maxTop () {
      return this.verticallegth - Math.ceil(this.size / 2)
    },
    minX () {
      return this.left - Math.floor(this.size / 2)
    },
    maxX () {
      return this.minX + this.size - 1
    },
    minY () {
      return this.top - Math.floor(this.size / 2)
    },
    maxY () {
      return this.minY + this.size - 1
    },
    pointsInfo () {
      const res = []
      for (let j = this.minY; j <= this.maxY; j++) {
        for (let index = this.minX; index <= this.maxX; index++) {
          res.push({
            x: index,
            y: j,
            num: (j - this.minY) * this.size + (index - this.minX) + 1
          })
        }
      }
      return res
    },
    circleBlankLeaving () {
      if (this.isCircle) {
        return (this.diameter - this.horizontal) / 2
      } else {
        return 0
      }
    },
    leftLength () {
      return Number.parseFloat(
        (this.left * this.sidelength + this.circleBlankLeaving).toFixed(2)
      )
    },
    topLength () {
      return Number.parseFloat(
        (this.top * this.sidelength + this.circleBlankLeaving).toFixed(2)
      )
    },
    rightLength () {
      return Number.parseFloat(
        (
          this.horizontal -
          this.leftLength +
          this.circleBlankLeaving * 2
        ).toFixed(2)
      )
    },
    bottomLength () {
      return Number.parseFloat(
        (this.vertical - this.topLength + +this.circleBlankLeaving * 2).toFixed(
          2
        )
      )
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    getMinX (left, size, length) {
      return (left - Math.floor(size / 2)) / length
    },
    getMinY (top, size, length) {
      return (top - Math.floor(size / 2)) / length
    },
    sizeChange (size) {
      this.size = size
      this.initSquare(true)
    },
    async editOld () {
      this.$loading.show()
      const points = this.getAllPointInfo()
      const data = {
        grainstore: this.storeId,
        name: this.name,
        IP: this.IP,
        accountName: this.account,
        password: this.password,
        eqId: this.setting.objectId,
        left: this.left,
        top: this.top,
        width: this.horizontallength,
        height: this.verticallegth,
        side: this.size,
        // time: this.time,
        leftLength: this.sidelength * this.left,
        topLength: this.sidelength * this.top,
        points: points
      }
      try {
        await this.$tkParse.post('/eq/update', data)
        this.$notification['success']({
          message: '操作成功',
          description: '数据保存成功'
        })
        this.$emit('updateEq')
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.$loading.hide()
    },
    async createNew () {
      this.$loading.show()
      const points = this.getAllPointInfo()
      const data = {
        name: this.name,
        IP: this.IP,
        accountName: this.account,
        password: this.password,
        grainstore: this.storeId,
        left: this.left,
        top: this.top,
        width: this.horizontallength,
        height: this.verticallegth,
        side: this.size,
        // time: this.time,
        leftLength: this.sidelength * this.left,
        topLength: this.sidelength * this.top,
        points: points
      }
      try {
        await this.$tkParse.post('/eq/create', data)
        this.$notification['success']({
          message: '操作成功',
          description: '数据保存成功'
        })
        this.$emit('updateEq')
      } catch (e) {
        console.log(e)
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.$loading.hide()
    },
    validate () {
      if (this.name && this.IP && this.password) {
        const isIP = isIp()
        if (isIP(this.IP)) {
          this.$notification['error']({
            message: '数据错误',
            description: '请输入正确的IP地址'
          })
          return false
        } else {
          return true
        }
      } else {
        this.$notification['error']({
          message: '数据错误',
          description: '数据错误，请检查录入的信息'
        })
        return false
      }
    },
    save () {
      if (this.validate()) {
        if (this.setting) {
          this.editOld()
        } else {
          this.createNew()
        }
      }
    },
    getAllPointInfo () {
      return this.pointsInfo.map(element => {
        let XDia = element.x - this.left
        let yDia = element.y - this.top
        if (XDia >= 0) XDia++
        if (yDia >= 0) yDia++
        const verticalLength = Math.sqrt(
          Math.pow(Math.abs(XDia) * this.sidelength, 2) +
            Math.pow(Math.abs(yDia) * this.sidelength, 2)
        )

        const tan = this.height / (verticalLength / 2)
        const verticalAngle = Math.round((Math.atan(tan) * 180) / Math.PI)
        const horizontalargs = this.angle(element)
        return {
          store: this.storeId,
          vertical: verticalAngle,
          point: `${element.num}`,
          horizontal: horizontalargs.angle
        }
      })
    },
    angle (start) {
      // 转化为直角坐标系
      const startX = start.x - this.left
      const startY = this.top - start.y
      let angle = Math.atan2(startY, startX)
      angle = Math.abs(Math.round((angle * 180) / Math.PI))
      if (startY > 0) {
        angle = 360 - angle
      }
      return {
        x: startX,
        y: startY,
        angle
      }
    },
    isInPoint (num) {
      const { x, y } = this.getCoordinate(num)
      const index = this.pointsInfo.findIndex(element => {
        return element.x === x && element.y === y
      })
      if (index > -1) {
        return this.pointsInfo[index].num
      } else {
        return null
      }
    },
    initData () {
      if (this.setting) {
        this.name = this.setting.name
        this.IP = this.setting.IP
        this.size = this.setting.side
        this.account = this.setting.accountName
        this.password = this.setting.password
        // this.time = this.setting.time
      } else {
        this.size = 7
      }
      this.initSquare()
    },
    initSquare (reset = false) {
      // 每个小正方形的边长
      // this.sidelength = (this.height * multiple) / (this.size / 2)
      const maxLength = Math.min(this.cameraLength, this.vertical)
      this.sidelength = maxLength / this.size
      // 方形的个数
      this.horizontallength = Math.round(this.horizontal / this.sidelength)
      this.verticallegth = Math.round(this.vertical / this.sidelength)
      if (this.setting && !reset) {
        this.top = this.setting.top
        this.left = this.setting.left
      } else {
        this.top = parseInt(this.verticallegth / 2)
        this.left = parseInt(this.horizontallength / 2)
      }
    },
    getCoordinate (num) {
      const y = Math.floor((num - 1) / this.horizontallength)
      const x = num - 1 - this.horizontallength * y
      return { x, y }
    },
    isCenter (num) {
      const { x, y } = this.getCoordinate(num)
      return x === this.left && y === this.top
    },
    isInRange (num) {
      const { x, y } = this.getCoordinate(num)
      return (
        x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY
      )
    },
    startChangeCenter (num) {
      if (this.isCenter(num)) {
        this.canUpdateCenter = true
      } else {
        this.canUpdateCenter = false
      }
    },
    stopChangeCenter () {
      this.canUpdateCenter = false
    },
    changeCenter (num) {
      if (!this.canUpdateCenter) return
      const { x, y } = this.getCoordinate(num)
      if (x < this.minLeft) {
        this.left = this.minLeft
      } else if (x > this.maxLeft) {
        this.left = this.maxLeft
      } else {
        this.left = x
      }
      if (y < this.minTop) {
        this.top = this.minTop
      } else if (y > this.maxTop) {
        this.top = this.maxTop
      } else {
        this.top = y
      }
    },
    clickItem (num) {
      this.canUpdateCenter = true
      this.changeCenter(num)
      this.canUpdateCenter = false
    },
    addTimes () {
      this.times.push('')
    },
    deleteTimes (index) {
      this.times.splice(index, 1)
    }
  }
}
</script>
<style>
.dist {
  background-color: #ff3d00;
  position: absolute;
  z-index: 10;
}
.left-dist {
  top: 0;
  right: 100%;
  height: 1px;
}
.top-dist {
  width: 1px;
  left: -2px;
  bottom: 100%;
}
.right-dist {
  top: 0;
  height: 1px;
}
.bottom-dist {
  top: 0;
  left: -2px;
  width: 1px;
}
.dist-desc {
  margin: 10px;
  padding: 3px 5px;
  background-color: #ff3d00;
  color: #fff;
  border-radius: 3px;
}
</style>
